/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BannerAddDto } from '../models/BannerAddDto';
import type { BannerUpdateDto } from '../models/BannerUpdateDto';
import type { BaseResponseDto_AnyResponseDto } from '../models/BaseResponseDto_AnyResponseDto';
import type { BaseResponseDto_DashboardAllResponse } from '../models/BaseResponseDto_DashboardAllResponse';
import type { BaseResponseDto_IsLoginResponse } from '../models/BaseResponseDto_IsLoginResponse';
import type { BaseResponseDto_LogDetailResponse } from '../models/BaseResponseDto_LogDetailResponse';
import type { BaseResponseDto_LoginResponse } from '../models/BaseResponseDto_LoginResponse';
import type { BaseResponseDto_ManagerDetailResponse } from '../models/BaseResponseDto_ManagerDetailResponse';
import type { BaseResponseDto_ManagerDetailResponseTree } from '../models/BaseResponseDto_ManagerDetailResponseTree';
import type { BaseResponseDto_ManagerPermissionBaseResData } from '../models/BaseResponseDto_ManagerPermissionBaseResData';
import type { BaseResponseDto_ManagerRoleBaseResData } from '../models/BaseResponseDto_ManagerRoleBaseResData';
import type { BaseResponseDto_RecentActivityResponse } from '../models/BaseResponseDto_RecentActivityResponse';
import type { BaseResponseDto_SystemLogDetailResponse } from '../models/BaseResponseDto_SystemLogDetailResponse';
import type { BaseResponseDto_SystemOverviewResponse } from '../models/BaseResponseDto_SystemOverviewResponse';
import type { BaseResponseDto_SystemStatusResponse } from '../models/BaseResponseDto_SystemStatusResponse';
import type { BaseResponseDto_UserDetailResponse } from '../models/BaseResponseDto_UserDetailResponse';
import type { BaseResponseDto_UserPermissionBaseResData } from '../models/BaseResponseDto_UserPermissionBaseResData';
import type { BaseResponseDto_UserPermissionResponse } from '../models/BaseResponseDto_UserPermissionResponse';
import type { BaseResponseDto_UserRoleBaseResData } from '../models/BaseResponseDto_UserRoleBaseResData';
import type { BaseSucResponseDto_Array } from '../models/BaseSucResponseDto_Array';
import type { CategoryAddDto } from '../models/CategoryAddDto';
import type { CategoryUpdateDto } from '../models/CategoryUpdateDto';
import type { ChangeEmailDto } from '../models/ChangeEmailDto';
import type { ChangePhoneDto } from '../models/ChangePhoneDto';
import type { ChatMessageReplyDto } from '../models/ChatMessageReplyDto';
import type { CheckEmailCodeDto } from '../models/CheckEmailCodeDto';
import type { CheckSmsDto } from '../models/CheckSmsDto';
import type { ClientUserRegisterDto } from '../models/ClientUserRegisterDto';
import type { CreateResponseDto_AnyResponseDto } from '../models/CreateResponseDto_AnyResponseDto';
import type { CreateResponseDto_LogDetailResponse } from '../models/CreateResponseDto_LogDetailResponse';
import type { CreateResponseDto_ManagerDetailResponse } from '../models/CreateResponseDto_ManagerDetailResponse';
import type { CreateResponseDto_ManagerPermissionBaseResData } from '../models/CreateResponseDto_ManagerPermissionBaseResData';
import type { CreateResponseDto_ManagerRoleBaseResData } from '../models/CreateResponseDto_ManagerRoleBaseResData';
import type { CreateResponseDto_SystemLogDetailResponse } from '../models/CreateResponseDto_SystemLogDetailResponse';
import type { CreateResponseDto_UserDetailResponse } from '../models/CreateResponseDto_UserDetailResponse';
import type { CreateResponseDto_UserPermissionBaseResData } from '../models/CreateResponseDto_UserPermissionBaseResData';
import type { CreateResponseDto_UserRoleBaseResData } from '../models/CreateResponseDto_UserRoleBaseResData';
import type { EmailCodeDto } from '../models/EmailCodeDto';
import type { FileUploadDto } from '../models/FileUploadDto';
import type { LogCollectDto } from '../models/LogCollectDto';
import type { LoginDto } from '../models/LoginDto';
import type { LogPutDto } from '../models/LogPutDto';
import type { LogSaveDto } from '../models/LogSaveDto';
import type { ManagerAddDto } from '../models/ManagerAddDto';
import type { ManagerPermissionPutDto } from '../models/ManagerPermissionPutDto';
import type { ManagerPermissionSaveDto } from '../models/ManagerPermissionSaveDto';
import type { ManagerRolePutDto } from '../models/ManagerRolePutDto';
import type { ManagerRoleSaveDto } from '../models/ManagerRoleSaveDto';
import type { ManagerUpdateDto } from '../models/ManagerUpdateDto';
import type { NewsAddDto } from '../models/NewsAddDto';
import type { NewsUpdateDto } from '../models/NewsUpdateDto';
import type { OperationResponseDto } from '../models/OperationResponseDto';
import type { PaginatedResponse_AnyResponseDto } from '../models/PaginatedResponse_AnyResponseDto';
import type { PaginatedResponse_LogDetailResponse } from '../models/PaginatedResponse_LogDetailResponse';
import type { PaginatedResponse_ManagerDetailResponse } from '../models/PaginatedResponse_ManagerDetailResponse';
import type { PaginatedResponse_ManagerPermissionBaseResData } from '../models/PaginatedResponse_ManagerPermissionBaseResData';
import type { PaginatedResponse_ManagerRoleBaseResData } from '../models/PaginatedResponse_ManagerRoleBaseResData';
import type { PaginatedResponse_SystemLogDetailResponse } from '../models/PaginatedResponse_SystemLogDetailResponse';
import type { PaginatedResponse_UserDetailResponse } from '../models/PaginatedResponse_UserDetailResponse';
import type { PaginatedResponse_UserPermissionBaseResData } from '../models/PaginatedResponse_UserPermissionBaseResData';
import type { PaginatedResponse_UserRoleBaseResData } from '../models/PaginatedResponse_UserRoleBaseResData';
import type { ProductAddDto } from '../models/ProductAddDto';
import type { ProductUpdateDto } from '../models/ProductUpdateDto';
import type { SiteConfigPutDto } from '../models/SiteConfigPutDto';
import type { SmsCodeDto } from '../models/SmsCodeDto';
import type { SystemLogBatchDelDto } from '../models/SystemLogBatchDelDto';
import type { SystemLogPutDto } from '../models/SystemLogPutDto';
import type { SystemLogSaveDto } from '../models/SystemLogSaveDto';
import type { UserAddDto } from '../models/UserAddDto';
import type { UserLoginDto } from '../models/UserLoginDto';
import type { UserPermissionPutDto } from '../models/UserPermissionPutDto';
import type { UserPermissionSaveDto } from '../models/UserPermissionSaveDto';
import type { UserRolePutDto } from '../models/UserRolePutDto';
import type { UserRoleSaveDto } from '../models/UserRoleSaveDto';
import type { UserUpdateDto } from '../models/UserUpdateDto';
import type { WechatQrCodeCheckDto } from '../models/WechatQrCodeCheckDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Service {
    /**
     * 获取列表
     * 获取数据列表，支持分页查询
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_LogDetailResponse 获取数据列表成功
     * @throws ApiError
     */
    public static logControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_LogDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/log',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 保存数据
     * 创建新的数据记录
     * @param requestBody 日志数据
     * @returns CreateResponseDto_LogDetailResponse 创建成功
     * @throws ApiError
     */
    public static logControllerSave(
        requestBody: LogSaveDto,
    ): CancelablePromise<CreateResponseDto_LogDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/log',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新数据
     * 更新数据记录，需要JWT认证
     * @param requestBody 日志更新数据
     * @returns OperationResponseDto 更新数据成功
     * @throws ApiError
     */
    public static logControllerPut(
        requestBody: LogPutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/log',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除数据
     * 根据ID删除数据记录，需要JWT认证
     * @param id id
     * @returns OperationResponseDto 删除数据成功
     * @throws ApiError
     */
    public static logControllerDeleteLog(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/log/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取详情
     * 根据ID获取数据的详细信息，需要IPS认证
     * @param id id
     * @returns BaseResponseDto_LogDetailResponse 获取数据详情成功
     * @throws ApiError
     */
    public static logControllerGetLogDetail(
        id: number,
    ): CancelablePromise<BaseResponseDto_LogDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/log/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增管理员
     * @param requestBody 管理员信息
     * @returns CreateResponseDto_ManagerDetailResponse 创建成功
     * @throws ApiError
     */
    public static managerControllerAdd(
        requestBody: ManagerAddDto,
    ): CancelablePromise<CreateResponseDto_ManagerDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/manager',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 获取管理员列表
     * 非 superManager 角色不展示拥有 superManager 角色的管理员
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_ManagerDetailResponse 获取数据列表成功
     * @throws ApiError
     */
    public static managerControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_ManagerDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/manager',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 更新管理员信息
     * @param requestBody 管理员更新信息
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static managerControllerPut(
        requestBody: ManagerUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/manager',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 管理员登录
     * @param requestBody 登录信息
     * @returns BaseResponseDto_ManagerDetailResponse 登录成功
     * @throws ApiError
     */
    public static managerControllerLogins(
        requestBody: LoginDto,
    ): CancelablePromise<BaseResponseDto_ManagerDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/manager/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取管理员详情
     * @returns BaseResponseDto_ManagerDetailResponseTree 获取数据列表成功
     * @throws ApiError
     */
    public static managerControllerGetPermission(): CancelablePromise<BaseResponseDto_ManagerDetailResponseTree> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/manager/detail',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 退出登录
     * @returns any
     * @throws ApiError
     */
    public static managerControllerSetExit(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/manager/exit',
        });
    }
    /**
     * 删除管理员
     * @param managerId 管理员ID
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static managerControllerDelete(
        managerId: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/manager/{managerId}',
            path: {
                'managerId': managerId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取系统日志列表
     * 获取系统日志列表，支持分页查询和多种条件筛选
     * @param pn 页码
     * @param rn 每页数量
     * @param logType 日志类型
     * @param module 操作模块
     * @param userId 用户ID
     * @param level 日志级别
     * @param startTime 开始时间戳
     * @param endTime 结束时间戳
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_SystemLogDetailResponse 获取系统日志列表成功
     * @throws ApiError
     */
    public static systemLogControllerGetList(
        pn: number = 1,
        rn: number = 10,
        logType?: 'LOGIN' | 'LOGOUT' | 'OPERATION' | 'API_CALL' | 'ERROR' | 'SYSTEM_INFO' | 'SECURITY',
        module?: string,
        userId?: string,
        level?: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR',
        startTime?: number,
        endTime?: number,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_SystemLogDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/systemLog',
            query: {
                'pn': pn,
                'rn': rn,
                'logType': logType,
                'module': module,
                'userId': userId,
                'level': level,
                'startTime': startTime,
                'endTime': endTime,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 保存系统日志
     * 创建新的系统日志记录
     * @param requestBody 系统日志数据
     * @returns CreateResponseDto_SystemLogDetailResponse 创建成功
     * @throws ApiError
     */
    public static systemLogControllerSave(
        requestBody: SystemLogSaveDto,
    ): CancelablePromise<CreateResponseDto_SystemLogDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新系统日志
     * 更新系统日志记录，需要JWT认证
     * @param requestBody 系统日志更新数据
     * @returns OperationResponseDto 更新系统日志成功
     * @throws ApiError
     */
    public static systemLogControllerUpdate(
        requestBody: SystemLogPutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/systemLog',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除系统日志
     * 根据ID删除系统日志记录，需要JWT认证
     * @param id id
     * @returns OperationResponseDto 删除系统日志成功
     * @throws ApiError
     */
    public static systemLogControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/systemLog/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取系统日志详情
     * 根据ID获取系统日志的详细信息，需要JWT认证
     * @param id id
     * @returns BaseResponseDto_SystemLogDetailResponse 获取系统日志详情成功
     * @throws ApiError
     */
    public static systemLogControllerGetDetail(
        id: number,
    ): CancelablePromise<BaseResponseDto_SystemLogDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/systemLog/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 批量删除系统日志
     * 批量删除系统日志记录，需要JWT认证
     * @param requestBody 要删除的ID数组
     * @returns OperationResponseDto 批量删除系统日志成功
     * @throws ApiError
     */
    public static systemLogControllerBatchDelete(
        requestBody: SystemLogBatchDelDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/batchDelete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 收集日志
     * 用于收集和记录各种类型的系统日志
     * @param requestBody 日志收集数据
     * @returns CreateResponseDto_SystemLogDetailResponse 创建成功
     * @throws ApiError
     */
    public static systemLogControllerCollectLog(
        requestBody: LogCollectDto,
    ): CancelablePromise<CreateResponseDto_SystemLogDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/collect',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 记录用户登录日志
     * 专门用于记录用户登录相关的日志
     * @returns OperationResponseDto 记录用户登录日志成功
     * @throws ApiError
     */
    public static systemLogControllerLogUserLogin(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/logLogin',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 记录用户操作日志
     * 专门用于记录用户操作行为的日志
     * @returns OperationResponseDto 记录用户操作日志成功
     * @throws ApiError
     */
    public static systemLogControllerLogUserOperation(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/logOperation',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 记录API调用日志
     * 专门用于记录API调用相关的日志
     * @returns OperationResponseDto 记录API调用日志成功
     * @throws ApiError
     */
    public static systemLogControllerLogApiCall(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/logApiCall',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 记录系统错误日志
     * 专门用于记录系统错误相关的日志
     * @returns OperationResponseDto 记录系统错误日志成功
     * @throws ApiError
     */
    public static systemLogControllerLogSystemError(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/logError',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 清理过期日志
     * 清理指定天数之前的过期日志记录
     * @returns OperationResponseDto 清理过期日志成功
     * @throws ApiError
     */
    public static systemLogControllerCleanExpiredLogs(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/systemLog/cleanExpired',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取日志统计信息
     * 获取系统日志的统计信息，可按时间范围筛选
     * @returns OperationResponseDto 获取日志统计信息成功
     * @throws ApiError
     */
    public static systemLogControllerGetLogStatistics(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/systemLog/statistics/overview',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取权限列表
     * 获取权限数据列表，支持分页查询
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_ManagerPermissionBaseResData 获取权限列表成功
     * @throws ApiError
     */
    public static managerPermissionControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_ManagerPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/managerPermission',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 创建权限
     * 创建新的权限记录
     * @param requestBody 权限信息
     * @returns CreateResponseDto_ManagerPermissionBaseResData 创建成功
     * @throws ApiError
     */
    public static managerPermissionControllerSave(
        requestBody: ManagerPermissionSaveDto,
    ): CancelablePromise<CreateResponseDto_ManagerPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/managerPermission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新权限
     * 更新权限记录，需要JWT认证
     * @param requestBody 权限更新信息
     * @returns OperationResponseDto 更新权限成功
     * @throws ApiError
     */
    public static managerPermissionControllerPut(
        requestBody: ManagerPermissionPutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/managerPermission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除权限
     * 根据ID删除权限记录，需要JWT认证
     * @param permissionId 权限ID
     * @returns OperationResponseDto 删除权限成功
     * @throws ApiError
     */
    public static managerPermissionControllerDelete(
        permissionId: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/managerPermission/{permissionId}',
            path: {
                'permissionId': permissionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取权限详情
     * 根据ID获取权限的详细信息，需要JWT认证
     * @param permissionId 权限ID
     * @returns BaseResponseDto_ManagerPermissionBaseResData 获取权限详情成功
     * @throws ApiError
     */
    public static managerPermissionControllerGetPermissionDetail(
        permissionId: number,
    ): CancelablePromise<BaseResponseDto_ManagerPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/managerPermission/{permissionId}',
            path: {
                'permissionId': permissionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取角色列表
     * 获取角色数据列表，支持分页查询；superManager 角色仅当前用户拥有 superManager 时可见
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_ManagerRoleBaseResData 获取角色列表成功
     * @throws ApiError
     */
    public static managerRoleControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_ManagerRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/managerRole',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 创建角色
     * 创建新的角色记录
     * @param requestBody 角色信息
     * @returns CreateResponseDto_ManagerRoleBaseResData 创建成功
     * @throws ApiError
     */
    public static managerRoleControllerSave(
        requestBody: ManagerRoleSaveDto,
    ): CancelablePromise<CreateResponseDto_ManagerRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/managerRole',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新角色
     * 更新角色记录，需要JWT认证
     * @param requestBody 角色更新信息
     * @returns OperationResponseDto 更新角色成功
     * @throws ApiError
     */
    public static managerRoleControllerPut(
        requestBody: ManagerRolePutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/managerRole',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除角色
     * 根据ID删除角色记录，需要JWT认证
     * @param roleId 角色ID
     * @returns OperationResponseDto 删除角色成功
     * @throws ApiError
     */
    public static managerRoleControllerDelete(
        roleId: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/managerRole/{roleId}',
            path: {
                'roleId': roleId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取角色详情
     * 根据ID获取角色的详细信息，需要JWT认证
     * @param roleId 角色ID
     * @returns BaseResponseDto_ManagerRoleBaseResData 获取角色详情成功
     * @throws ApiError
     */
    public static managerRoleControllerGetRoleDetail(
        roleId: number,
    ): CancelablePromise<BaseResponseDto_ManagerRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/managerRole/{roleId}',
            path: {
                'roleId': roleId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增用户
     * @param requestBody 用户信息
     * @returns CreateResponseDto_UserDetailResponse 创建成功
     * @throws ApiError
     */
    public static userControllerAdd(
        requestBody: UserAddDto,
    ): CancelablePromise<CreateResponseDto_UserDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 获取用户列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_UserDetailResponse 获取数据列表成功
     * @throws ApiError
     */
    public static userControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_UserDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/user',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 更新用户信息
     * @param requestBody 用户更新信息
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static userControllerPut(
        requestBody: UserUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除用户
     * @param id 用户ID
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static userControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取用户详情
     * @returns BaseResponseDto_UserDetailResponse 获取用户详情成功
     * @throws ApiError
     */
    public static userControllerGetUserDetail(): CancelablePromise<BaseResponseDto_UserDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/user/{id}',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取功能列表
     * 获取功能数据列表，支持分页查询
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_UserPermissionBaseResData 获取功能列表成功
     * @throws ApiError
     */
    public static userPermissionControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_UserPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/userPermission',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 创建功能
     * 创建新的功能记录
     * @param requestBody 功能信息
     * @returns CreateResponseDto_UserPermissionBaseResData 创建成功
     * @throws ApiError
     */
    public static userPermissionControllerSave(
        requestBody: UserPermissionSaveDto,
    ): CancelablePromise<CreateResponseDto_UserPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/userPermission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新功能
     * 更新功能记录，需要JWT认证
     * @param requestBody 功能更新信息
     * @returns OperationResponseDto 更新功能成功
     * @throws ApiError
     */
    public static userPermissionControllerPut(
        requestBody: UserPermissionPutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/userPermission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除功能
     * 根据ID删除功能记录，需要JWT认证
     * @param permissionId 功能ID
     * @returns OperationResponseDto 删除功能成功
     * @throws ApiError
     */
    public static userPermissionControllerDelete(
        permissionId: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/userPermission/{permissionId}',
            path: {
                'permissionId': permissionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取功能详情
     * 根据ID获取功能的详细信息，需要JWT认证
     * @param permissionId 功能ID
     * @returns BaseResponseDto_UserPermissionBaseResData 获取功能详情成功
     * @throws ApiError
     */
    public static userPermissionControllerGetFeatureDetail(
        permissionId: number,
    ): CancelablePromise<BaseResponseDto_UserPermissionBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/userPermission/{permissionId}',
            path: {
                'permissionId': permissionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取角色列表
     * 获取角色数据列表，支持分页查询
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_UserRoleBaseResData 获取角色列表成功
     * @throws ApiError
     */
    public static userRoleControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_UserRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/userRole',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 创建角色
     * 创建新的角色记录
     * @param requestBody 角色信息
     * @returns CreateResponseDto_UserRoleBaseResData 创建成功
     * @throws ApiError
     */
    public static userRoleControllerSave(
        requestBody: UserRoleSaveDto,
    ): CancelablePromise<CreateResponseDto_UserRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/userRole',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新角色
     * 更新角色记录，需要JWT认证
     * @param requestBody 角色更新信息
     * @returns OperationResponseDto 更新角色成功
     * @throws ApiError
     */
    public static userRoleControllerPut(
        requestBody: UserRolePutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/userRole',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除角色
     * 根据ID删除角色记录，需要JWT认证
     * @param roleId 角色ID
     * @returns OperationResponseDto 删除角色成功
     * @throws ApiError
     */
    public static userRoleControllerDelete(
        roleId: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/userRole/{roleId}',
            path: {
                'roleId': roleId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取角色详情
     * 根据ID获取角色的详细信息，需要JWT认证
     * @param roleId 角色ID
     * @returns BaseResponseDto_UserRoleBaseResData 获取角色详情成功
     * @throws ApiError
     */
    public static userRoleControllerGetRoleDetail(
        roleId: number,
    ): CancelablePromise<BaseResponseDto_UserRoleBaseResData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/userRole/{roleId}',
            path: {
                'roleId': roleId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取系统概览数据
     * 返回系统统计概览信息，包括账号总数、日志数量、用户总数等
     * @returns BaseResponseDto_SystemOverviewResponse 获取系统概览数据成功
     * @throws ApiError
     */
    public static dashboardControllerGetSystemOverview(): CancelablePromise<BaseResponseDto_SystemOverviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/dashboard/overview',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取最近活动
     * 返回系统最近的活动记录，如登录、配置更新等
     * @returns BaseResponseDto_RecentActivityResponse 获取最近活动成功
     * @throws ApiError
     */
    public static dashboardControllerGetRecentActivities(): CancelablePromise<BaseResponseDto_RecentActivityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/dashboard/recent-activities',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取系统状态
     * 返回系统各组件状态，如数据库连接、服务器状态、存储空间等
     * @returns BaseResponseDto_SystemStatusResponse 获取系统状态成功
     * @throws ApiError
     */
    public static dashboardControllerGetSystemStatus(): CancelablePromise<BaseResponseDto_SystemStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/dashboard/system-status',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取完整概览数据
     * 一次性获取系统概览、最近活动和系统状态的所有数据
     * @returns BaseResponseDto_DashboardAllResponse 获取完整概览数据成功
     * @throws ApiError
     */
    public static dashboardControllerGetAllDashboardData(): CancelablePromise<BaseResponseDto_DashboardAllResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/dashboard/all',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 分类列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycCategoryControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/category',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增分类
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycCategoryControllerAdd(
        requestBody: CategoryAddDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新分类
     * @param requestBody
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static ycCategoryControllerPut(
        requestBody: CategoryUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 分类详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycCategoryControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/category/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除分类
     * @param id id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycCategoryControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/category/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 产品列表
     * @param pn 页码
     * @param rn 每页数量
     * @param category 分类 key
     * @param custom 自定义模糊查询
     * @param status 状态 published|draft|offline
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycProductControllerGet(
        pn: number = 1,
        rn: number = 10,
        category?: string,
        custom?: string,
        status?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/product',
            query: {
                'pn': pn,
                'rn': rn,
                'category': category,
                'custom': custom,
                'status': status,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增产品
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycProductControllerAdd(
        requestBody: ProductAddDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新产品
     * @param requestBody
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static ycProductControllerPut(
        requestBody: ProductUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 产品详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycProductControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/product/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除产品
     * @param id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycProductControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/product/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新闻列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycNewsControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/news',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增新闻
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycNewsControllerAdd(
        requestBody: NewsAddDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/news',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新新闻
     * @param requestBody
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static ycNewsControllerPut(
        requestBody: NewsUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/news',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新闻详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycNewsControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/news/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除新闻
     * @param id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycNewsControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/news/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 轮播列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycBannerControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/banner',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增轮播
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycBannerControllerAdd(
        requestBody: BannerAddDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/banner',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新轮播
     * @param requestBody
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static ycBannerControllerPut(
        requestBody: BannerUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/banner',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 轮播详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycBannerControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/banner/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除轮播
     * @param id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycBannerControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/banner/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 配置列表或按 key 查询
     * @param key configKey
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycSiteConfigControllerGet(
        key?: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/siteConfig',
            query: {
                'key': key,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 保存配置(按 key 覆盖)
     * @param requestBody
     * @returns OperationResponseDto 保存成功
     * @throws ApiError
     */
    public static ycSiteConfigControllerPut(
        requestBody: SiteConfigPutDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/siteConfig',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 联系表单列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycContactSubmissionControllerGetList(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/contactSubmission',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 联系表单详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycContactSubmissionControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/contactSubmission/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除联系记录
     * @param id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycContactSubmissionControllerDelete(
        id: string,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/contactSubmission/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 会话列表
     * @param pn 页码
     * @param rn 每页数量
     * @param sessionId 会话 id 模糊
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycChatMessageControllerGetSessions(
        pn: number = 1,
        rn: number = 10,
        sessionId?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/chatMessage/sessions',
            query: {
                'pn': pn,
                'rn': rn,
                'sessionId': sessionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 某会话消息列表
     * @param sessionId
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycChatMessageControllerGetMessages(
        sessionId: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/chatMessage/messages',
            query: {
                'sessionId': sessionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 回复聊天（管理员）
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycChatMessageControllerReply(
        requestBody: ChatMessageReplyDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/chatMessage/reply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 新增用户
     * @param requestBody
     * @returns CreateResponseDto_UserDetailResponse 创建成功
     * @throws ApiError
     */
    public static userControllerAdd1(
        requestBody: ClientUserRegisterDto,
    ): CancelablePromise<CreateResponseDto_UserDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 发送短信验证码
     * @param requestBody
     * @returns OperationResponseDto 发送成功
     * @throws ApiError
     */
    public static userControllerGetSms(
        requestBody: SmsCodeDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/sms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 验证短信验证码
     * @param requestBody
     * @returns OperationResponseDto 验证成功
     * @throws ApiError
     */
    public static userControllerCheckSms(
        requestBody: CheckSmsDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/checkSms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 修改手机号
     * @param requestBody
     * @returns OperationResponseDto 修改成功
     * @throws ApiError
     */
    public static userControllerChangePhone(
        requestBody: ChangePhoneDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/changePhone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 发送邮箱验证码
     * @param requestBody
     * @returns OperationResponseDto 发送成功
     * @throws ApiError
     */
    public static userControllerEmailCode(
        requestBody: EmailCodeDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/emailCode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 验证邮箱验证码
     * @param requestBody
     * @returns OperationResponseDto 验证成功
     * @throws ApiError
     */
    public static userControllerCheckEmailCode(
        requestBody: CheckEmailCodeDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/checkEmailCode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 修改邮箱
     * @param requestBody
     * @returns OperationResponseDto 修改成功
     * @throws ApiError
     */
    public static userControllerChangeEmail(
        requestBody: ChangeEmailDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/changeEmail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 用户登录
     * @param requestBody
     * @returns BaseResponseDto_LoginResponse 登录成功
     * @throws ApiError
     */
    public static userControllerLogins(
        requestBody: UserLoginDto,
    ): CancelablePromise<BaseResponseDto_LoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 检查用户是否登录(主要检测token是否有效)
     * @returns BaseResponseDto_IsLoginResponse 用户已登录
     * @throws ApiError
     */
    public static userControllerIsLogin(): CancelablePromise<BaseResponseDto_IsLoginResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/user/isLogin',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取当前用户信息
     * @returns BaseResponseDto_UserDetailResponse 获取用户信息成功
     * @throws ApiError
     */
    public static userControllerGetUserTest(): CancelablePromise<BaseResponseDto_UserDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/user/userInfo',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取用户权限
     * @returns BaseResponseDto_UserPermissionResponse 获取权限成功
     * @throws ApiError
     */
    public static userControllerGetPermission(): CancelablePromise<BaseResponseDto_UserPermissionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/user/permission',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 用户退出登录
     * @returns OperationResponseDto 退出成功
     * @throws ApiError
     */
    public static userControllerSetExit(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/user/exit',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 注销账号
     * @returns OperationResponseDto 注销成功
     * @throws ApiError
     */
    public static userControllerDelete1(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/delete',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 获取关注服务号登录二维码（PC端显示）
     * @returns OperationResponseDto 获取二维码成功
     * @throws ApiError
     */
    public static userControllerGetWechatFollowQrCode(): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/user/wechat/follow/qrcode',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 检查关注服务号登录状态
     * @param requestBody
     * @returns OperationResponseDto 检查成功
     * @throws ApiError
     */
    public static userControllerCheckWechatFollowStatus(
        requestBody: WechatQrCodeCheckDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/wechat/follow/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 执行关注服务号登录
     * @param requestBody
     * @returns BaseResponseDto_LoginResponse 登录成功
     * @throws ApiError
     */
    public static userControllerWechatFollowLogin(
        requestBody: WechatQrCodeCheckDto,
    ): CancelablePromise<BaseResponseDto_LoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/user/wechat/follow/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 文件上传
     * 上传文件到COS
     * @param formData 文件上传表单
     * @returns BaseSucResponseDto_Array 文件上传成功
     * @throws ApiError
     */
    public static uploadControllerUpload(
        formData: FileUploadDto,
    ): CancelablePromise<BaseSucResponseDto_Array> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
